'use strict';

function _MoneyUpDashboardHomeBase() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];

  this._history = new History();
  this._productCell = null;
  this._productCellNode = null;

  this._getConnectionIssueConfig = function () {
    return {
      node: this.node.querySelector('.dashboard-product__content'),
      view: '/member/components/moneyup-product-cell-issue',
      isEntirePage: false,
      retryRequest: false,
      invocationCallback: this._onConnectionIssue.bind(this),
      tryAgainCallback: this._onConnectionIssueTryAgain.bind(this),
      callback: this._onRestoreAfterConnectionIssue.bind(this),
      finalFailCallback: this._onConnectionIssueFinalFail.bind(this)
    };
  };

  this._createProductCell = function (cellSettings) {
    var product = cellSettings.product,
        contentExtensions = cellSettings.contentExtensions,
        _cellSettings$classNa = cellSettings.classNameExtensions,
        classNameExtensions = _cellSettings$classNa === undefined ? {} : _cellSettings$classNa,
        _cellSettings$disclai = cellSettings.disclaimers,
        disclaimers = _cellSettings$disclai === undefined ? {} : _cellSettings$disclai,
        _cellSettings$analyti = cellSettings.analyticsState,
        analyticsState = _cellSettings$analyti === undefined ? '' : _cellSettings$analyti,
        _cellSettings$onReady = cellSettings.onReady,
        onReady = _cellSettings$onReady === undefined ? this._setState : _cellSettings$onReady;


    this._productCellNode = this._getProductCellNode();
    this._getProductCell().create('MoneyUpProductCell', {
      product: product,
      contentExtensions: contentExtensions,
      classNameExtensions: classNameExtensions,
      disclaimers: disclaimers,
      analyticsState: analyticsState,
      presenter: this.presenter,
      analytics: this.analytics,
      onReady: onReady
    });
  };

  this._onConnectionIssue = function () {
    this._productCellNode = this._getProductCellNode();
    this._productCellNode.classList.remove('dashboard-product-state--loading');
    this._productCellNode.classList.add('dashboard-product-state--connection-issue');
    this._history.removeHistoryNode(this._productCellNode);
    this._productCellNode.addEventListener('click', this._onConnectionIssueBlockProductLink);
    this.analytics.pushEvent('hd-cell-status-connection-error', {
      cell: [this.product],
      notification: ['Initial']
    });
  };

  this._onConnectionIssueTryAgain = function (event) {
    this._productCellNode = this._getProductCellNode();
    event.data.ConnectionErrorInstance.node.classList.remove('connection-error--show');
    this.node.querySelector('.dashboard-product__content').classList.add('dashboard-product__content--show');
    this._productCellNode.classList.remove('dashboard-product-state--connection-issue');
    this._productCellNode.classList.add('dashboard-product-state--loading');
    event.data.onTryAgain.bind(event.data.ConnectionErrorInstance, event);
    this._productCellNode.removeEventListener('click', this._onConnectionIssueBlockProductLink);
    this.analytics.pushEvent('hd-cell-status-connection-error', {
      cell: [this.product],
      notification: ['Try Again']
    });
  };

  this._onConnectionIssueFinalFail = function () {
    this._productCellNode = this._getProductCellNode();
    this._productCellNode.classList.remove('dashboard-product-state--loading');
    this._productCellNode.classList.add('dashboard-product-state--connection-issue');
    this._productCellNode.addEventListener('click', this._onConnectionIssueBlockProductLink);
    this.analytics.pushEvent('hd-cell-status-connection-error', {
      cell: [this.product],
      notification: ['Persistent']
    });
  };

  this._onConnectionIssueBlockProductLink = function (e) {
    e.preventDefault();
  };

  // over-rideable if required
  this._onRestoreAfterConnectionIssue = function () {
    this._restoreProductDashboardLink();
  };

  this._restoreProductDashboardLink = function () {
    this._productCellNode = this._getProductCellNode();
    this._productCellNode.classList.remove('dashboard-product-state--loading');
    this._history.addHistoryNode(this._productCellNode, this._productCellNode.getAttribute('href'));
  };

  this._getProductCell = function () {
    return this._getProductCellNode().mogo();
  };

  this._getProductCellNode = function () {
    return this.node.querySelector('.js--dashboard-product');
  };

  // over-ride in classes that extend this class
  this._setState = function () {};
}